import request from '@/utils/request'

let Government_investmentApi = {

  /*政府招商活动列表*/
  list(data) {
    return request._post('/shop/plus.government_investment.Index/index', data);
},
/*添加政府招商活动*/
add(data) {
    return request._post('/shop/plus.government_investment.Index/add', data);
},
/*修改政府招商活动*/
edit(data) {
    return request._post('/shop/plus.government_investment.Index/edit', data);
},
/*删除政府招商活动*/
del(data) {
    return request._post('/shop/plus.government_investment.Index/del', data);
},
/*政府招商活动详情*/
detail(data) {
  return request._post('/shop/plus.government_investment.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.government_investment.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.government_investment.Setting/getSetting', data, errorback);
    },
}
export default Government_investmentApi;



// WEBPACK FOOTER //
// ./src/api/government_investment.js